import {
    TRANSACTION_PATH,
    CEREMONY_PATH,
    AUTHENTICATION_PATH,
    USER_AUTH_PATH,
    RECIPIENT_AUTH_PATH,
    SSO_AUTH_PATH,
    SENDER_AUTH_PATH,
    UNAUTHORIZED_PATH,
    ACCESS_DENIED_PATH,
    KBA_UNAVAILABLE_PATH,
    ACCESS_LOCKED_PATH,
    SESSION_EXPIRED_PATH,
    NOT_FOUND_PATH,
    LOGIN_PATH,
    FORCE_LOGIN_PATH,
    CONNECT_AUTHORIZE_PATH,
    EMAIL_ALIAS_CONFIRM_PATH,
    DASHBOARD_PATH,
    TEMPLATES_PATH,
    TEMPLATE_PATH,
    TRANSACTIONS_PATH,
    ARCHIVE_PATH,
    ARCHIVE_REQUEST_PATH,
    ACCOUNT_PATH,
    ADMIN_PATH,
    PASSWORD_RECOVERY_PATH,
    PASSWORD_RESET_PATH,
    REGISTRATION_PATH,
    USER_REGISTRATION_PATH,
    ACCOUNT_REGISTRATION_PATH,
    DESIGNER_PATH,
    DESIGN_PATH,
    ERROR_PATH,
    REPORTS_PATH,
    FAST_TRACK_PATH,
    SENDER_REPORT_PATH
} from '@constants';

export const mainRoutePaths = [
    {
        path: LOGIN_PATH,
        isPrivate: false,
        isSignerRoute: false
    },
    {
        path: FORCE_LOGIN_PATH,
        isPrivate: false,
        isSignerRoute: false
    },
    {
        path: PASSWORD_RECOVERY_PATH,
        isPrivate: false,
        isSignerRoute: false
    },
    {
        path: `${PASSWORD_RESET_PATH}/*`,
        isPrivate: false,
        isSignerRoute: false
    },
    {
        path: PASSWORD_RESET_PATH,
        isPrivate: false,
        isSignerRoute: false
    },
    {
        path: `${REGISTRATION_PATH}/*`,
        isPrivate: false,
        isSignerRoute: false
    },
    {
        path: `${USER_REGISTRATION_PATH}/:registrationId`,
        isPrivate: false,
        isSignerRoute: false
    },
    {
        path: `${ACCOUNT_REGISTRATION_PATH}/*`,
        isPrivate: false,
        isSignerRoute: false
    },
    {
        path: ERROR_PATH,
        isPrivate: false,
        isSignerRoute: false
    },
    {
        path: '/access-denied',
        isPrivate: true,
        isSignerRoute: false
    },
    {
        path: DASHBOARD_PATH,
        isPrivate: true,
        isSignerRoute: false
    },
    {
        path: `${TRANSACTIONS_PATH}/:query?`,
        isPrivate: true,
        isSignerRoute: false,
        isTransactionRestricted: true
    },
    {
        path: ARCHIVE_PATH,
        isPrivate: true,
        isSignerRoute: false
    },
    {
        path: ARCHIVE_REQUEST_PATH,
        isPrivate: true,
        isSignerRoute: false
    },
    {
        path: `${TRANSACTION_PATH}/:packageId${DESIGNER_PATH}/:subLink?`,
        isPrivate: true,
        isSignerRoute: false,
        isTransactionRestricted: true
    },
    {
        path: `${TRANSACTION_PATH}/:packageId${DESIGN_PATH}/:subLink?`,
        isPrivate: true,
        isSignerRoute: false,
        isTransactionRestricted: true
    },
    {
        path: `${TRANSACTION_PATH}/:packageId?`,
        isPrivate: true,
        isSignerRoute: false,
        isTransactionRestricted: true
    },
    {
        path: `${TEMPLATE_PATH}/:packageId${DESIGNER_PATH}/:subLink?`,
        isPrivate: true,
        isSignerRoute: false,
        isTransactionRestricted: true
    },
    {
        path: `${TEMPLATE_PATH}/:packageId${DESIGN_PATH}/:subLink?`,
        isPrivate: true,
        isSignerRoute: false,
        isTransactionRestricted: true
    },
    {
        path: TEMPLATES_PATH,
        isPrivate: true,
        isSignerRoute: false,
        isTransactionRestricted: true
    },
    {
        path: `${TEMPLATE_PATH}/:packageId?`,
        isPrivate: true,
        isSignerRoute: false,
        isTransactionRestricted: true
    },
    {
        path: ACCOUNT_PATH,
        isPrivate: true,
        isSignerRoute: false
    },
    {
        path: `${ACCOUNT_PATH}/*`,
        isPrivate: true,
        isSignerRoute: false
    },
    {
        path: ADMIN_PATH,
        isPrivate: true,
        isSignerRoute: false
    },
    {
        path: `${ADMIN_PATH}/*`,
        isPrivate: true,
        isSignerRoute: false
    },
    {
        path: REPORTS_PATH,
        isPrivate: true,
        isSignerRoute: false
    },
    {
        path: `${REPORTS_PATH}/:query?`,
        isPrivate: true,
        isSignerRoute: false
    },
    {
        path: `${REPORTS_PATH}${SENDER_REPORT_PATH}`,
        isPrivate: true,
        isSignerRoute: false
    },
    {
        path: FAST_TRACK_PATH,
        isPrivate: false,
        isSignerRoute: false
    },
    {
        path: `${SSO_AUTH_PATH}/*`,
        isPrivate: false,
        isSignerRoute: false
    },
    {
        // Private route: the connect consent page requires an authenticated
        // SenderUI session. The user no longer types their API key — on "Allow"
        // the backend derives it from the session (handleConnectApprove). An
        // unauthenticated user is redirected to login and returned here with the
        // connect query string (request_id, redirect_uri, client_name, state)
        // preserved (see handleUnauthenticatedRedirect).
        path: CONNECT_AUTHORIZE_PATH,
        isPrivate: true,
        isSignerRoute: false
    },
    {
        path: EMAIL_ALIAS_CONFIRM_PATH,
        isPrivate: true,
        isSignerRoute: false
    }
];

export const signerRoutePaths = [
    {
        path: `${TRANSACTION_PATH}/:packageId${CEREMONY_PATH}`,
        isPrivate: true,
        isSignerRoute: true
    },
    {
        path: `${USER_AUTH_PATH}/*`,
        isPrivate: false,
        isSignerRoute: true
    },
    {
        path: `${RECIPIENT_AUTH_PATH}/*`,
        isPrivate: false,
        isSignerRoute: true
    },
    {
        path: `${AUTHENTICATION_PATH}/*`,
        isPrivate: false,
        isSignerRoute: true
    },
    {
        path: `${UNAUTHORIZED_PATH}/recipient`,
        isPrivate: false,
        isSignerRoute: true
    },
    {
        path: `${ACCESS_DENIED_PATH}/recipient`,
        isPrivate: false,
        isSignerRoute: true
    },
    {
        path: `${KBA_UNAVAILABLE_PATH}/recipient`,
        isPrivate: false,
        isSignerRoute: true
    },
    {
        path: `${ACCESS_LOCKED_PATH}/recipient`,
        isPrivate: false,
        isSignerRoute: true
    },
    {
        path: `${SESSION_EXPIRED_PATH}/recipient`,
        isPrivate: false,
        isSignerRoute: true
    },
    {
        path: `${NOT_FOUND_PATH}/recipient`,
        isPrivate: false,
        isSignerRoute: true
    },
    {
        path: SENDER_AUTH_PATH,
        isPrivate: false,
        isSignerRoute: true
    }
];

export const getMainRouteConfig = (path) => mainRoutePaths.find((config) => config.path === path) || {};

export const getSignerRouteConfig = (path) => signerRoutePaths.find((config) => config.path === path) || {};
